import { getPinia } from '@/createPiniaSingleton';
import { createVueIsland } from '@/createVueIsland';
import Settings from './Settings.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
angular.module('leanlaw').controller('SettingsCtrl', ['$scope', '$rootScope', '$state', 'userService', 'alerts', function ($scope, $rootScope, $state, userService, alerts) {
  let vueApp = null;
  userService.me().then(me => {
    $scope.me = me;
    redirectIfNoAccess($state.current);
    $rootScope.$on('$stateChangeStart', (event, toState) => {
      redirectIfNoAccess(toState, event);
    });
    function redirectIfNoAccess(state, event) {
      if (state.name.indexOf('.company') > 0 && !me.permissions.firm.setup) {
        if (state.name === 'settings.company.m365' && me.features && me.features.m365) {
          return; // Don't redirect, allow access to Microsoft 365 tab
        }
        if (event) {
          event.preventDefault();
        }
        $state.go('settings.user');
      }
    }

    // Mount the Vue navigation component
    const navigationHost = document.getElementById('vue-settings-nav');
    if (navigationHost) {
      vueApp = createVueIsland(Settings, {
        userService,
        state: $state,
        rootScope: $rootScope,
        alerts
      });

      // Mount first, then initialize the store
      vueApp.mount(navigationHost);

      // Initialize the me store with the user data after mounting
      const pinia = getPinia();
      const meStore = useMeStore(pinia);
      meStore.$patch({
        me: me,
        terms: me.terms || {},
        features: me.features || {},
        settings: me.settings || {},
        company: me.company || {},
        permissions: me.permissions || {},
        access: me.access || {}
      });
    }
  });

  // Clean up when scope is destroyed
  $scope.$on('$destroy', () => {
    if (vueApp) {
      try {
        vueApp.unmount();
      } catch (e) {
        // Log unmount errors for debugging, but don't throw to avoid breaking cleanup
        console.warn('Vue app unmount error during cleanup:', e);
      } finally {
        // Clear the reference to prevent memory leaks during hybrid vue/angular lifecycle
        vueApp = null;
      }
    }
  });
}]);